// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {}

export const mutations = {}

export const actions = {
  fetchEmployeeLeaveRights(_, payload) {
    return ApiService.fetchEmployeeLeaveRights(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  editEmployeeLeaveRight(_, payload) {
    return ApiService.editEmployeeLeaveRight(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}
